import { trans } from "@mongez/localization";
import Is, { isEmpty } from "@mongez/supportive-is";

export function parseError(error: any) {
  if (error?.response) {
    error = error.response;
  }

  if (isEmpty(error)) {
    return error;
  }

  if ([405, 500, 401].includes(error.status)) {
    return trans("somethingWentWrong");
  }

  if (error.status === 404) {
    return trans("notFound");
  }

  if (error?.data?.errors) {
    error = error.data.errors;
  }

  if (error?.data?.error) {
    error = error.data.error;
  }

  let errorContent: any;

  if (Is.array(error)) {
    errorContent = (
      <div className="flex flex-col gap-2">
        {error.map((error: any) => {
          if (error.value || error.error) {
            return (
              <div key={error.key} className="text-gray-600">
                {error.value || error.error}
              </div>
            );
          }

          return error;
        })}
      </div>
    );
  } else {
    errorContent = error;
  }

  return errorContent;
}
